import { useMemo } from 'react'
import PropTypes from 'prop-types'
import { Container } from './CustomRouteStyle'
import { getOidcConfigName } from 'utils/functions'
import { withOidcSecure } from '@axa-fr/react-oidc'
import { useFooter } from 'providers/AreasProvider'
const { env } = require('utils/env')

const isAnonymous = JSON.parse(env.REACT_APP_WEBCHAT_IS_ANONYMOUS) // Webchat
const displaySidebar = JSON.parse(env.REACT_APP_WEBCHAT_DISPLAY_SIDEBAR)

function PrivateRoute({ component: Component }) {
  // if /lite, the isAnonymous on true, so we don't need to secure the route
  const SecuredComponent = useMemo(
    () => (isAnonymous ? Component : withOidcSecure(Component, undefined, undefined, getOidcConfigName())),
    [Component]
  )
  return <SecuredComponent />
}

PrivateRoute.propTypes = {
  component: PropTypes.func
}

function CustomRoute({ isPrivate = true, fullWidth = false, component: Component, ...props }) {
  const [footer] = useFooter()
  return (
    <Container footer={footer} fullWidth={fullWidth} displaySidebar={displaySidebar}>
      {isPrivate ? <PrivateRoute component={Component} {...props} /> : <Component {...props} />}
    </Container>
  )
}

CustomRoute.propTypes = {
  component: PropTypes.func,
  isPrivate: PropTypes.bool,
  fullWidth: PropTypes.bool,
  displaySidebar: PropTypes.bool
}

export default CustomRoute
